<template>
  <div id="custMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>客户设置</el-breadcrumb-item>
          <el-breadcrumb-item>APP激活码管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             class="pageSearch">
      <el-row>
        <el-col :span="22">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="激活码::">
            <el-input v-model="pageSearch.fKeyData"
                      placeholder="请输入激活码"
                      class="search"
                      style="width:200px;">
            </el-input>
          </el-form-item>
          <el-form-item label="设备地址::">
            <el-input placeholder="请输入设备地址"
                      v-model="pageSearch.fDevMacAddr"
                      class="search"
                      style="width:200px;"></el-input>
          </el-form-item>
          <el-form-item label="超过未使用天数::">
            <el-select v-model="pageSearch.fLastTime"
                       clearable
                       placeholder="请选择超过未使用天数"
                       style="width:200px;">
              <el-option v-for="item in fDaysList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="2"
                class="searchRowAdd">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-edit"
                     v-if="is_edit"
                     @click="handleAdd">新增激活码
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fDevAccNo"
                           label="操作员编号">
          </el-table-column>
          <!-- <el-table-column prop="fLinkman"
                           label="操作员姓名">
          </el-table-column> -->
          <el-table-column prop="fDevMacAddr"
                           label="设备Mac地址"
                           width="200px">
          </el-table-column>
          <el-table-column prop="fKeyData"
                           label="激活码">
          </el-table-column>
          <el-table-column prop="fLastTime"
                           label="操作时间">
          </el-table-column>
          <el-table-column prop="fStatusName"
                           width="80"
                           label="激活状态">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="300">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button size="mini"
                         type="danger"
                         v-if="is_del"
                         @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              <el-button size="mini"
                         type="info"
                         v-if="is_syn"
                         @click="custKeyRecovery(scope.$index, scope.row)">回收</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               id="custKeyDetailDialog"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="cust"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="最后更新时间::"
                          prop="fOpLastTime">
              <el-input v-model="cust.fOpLastTime"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最后更新用户::"
                          prop="fUsrName">
              <el-input v-model="cust.fUsrName"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户编号::"
                          prop="fCustNo">
              <el-input v-model="cust.fCustNo"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称::"
                          prop="fCustName">
              <el-input v-model="cust.fCustName"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="操作员编号::"
                          prop="fDevAccNo">
              <el-input v-model="cust.fDevAccNo"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作员姓名::"
                          prop="fLinkman">
              <el-input v-model="cust.fLinkman"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备Mac地址::"
                          prop="fDevMacAddr">
              <el-input v-model="cust.fDevMacAddr"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="激活码::"
                          prop="fKeyData">
              <el-input v-model="cust.fKeyData"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="最后操作时间::"
                          prop="fLastTime">
              <el-input v-model="cust.fLastTime"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="激活状态::"
                          prop="fStatusName">
              <el-input v-model="cust.fStatusName"
                        :disabled="formDisabled"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!formDisabled">保存</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div> -->
    </el-dialog>
    <el-dialog :title="dialogKeyTitle"
               id="custKeyDialog"
               top="7vh"
               width="40%"
               v-dialogDrag
               :visible.sync="dialogKeyFormVisible">
      <el-form :model="custKey"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="激活码::"
                          prop="fKeyData">
              <el-input v-model="custKey.fKeyData"
                        :disabled="keyFormDisabled"
                        placeholder="请填写激活码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!keyFormDisabled">保存</el-button>
        <el-button @click="dialogKeyFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { cust as api } from '../../api/cust'
import * as park from '../../api/park'
import * as user from '../../api/user'
// import $ from 'jquery'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_edit: false,
      is_del: false,
      is_syn: false,
      formDisabled: false,
      keyFormDisabled: false,
      tableHeight: 0,
      fGrpNo: '',
      custTypeIDList: [{ value: '0', label: '封闭式场库' }, { value: '1', label: '路侧场库' }],
      fDaysList: [{ value: 30, label: '30天' }, { value: 60, label: '60天' }, { value: 90, label: '90天' }, { value: 180, label: '180天' }, { value: 360, label: '360天' }],
      dialogFormVisible: false,
      dialogKeyFormVisible: false,
      loading: true,
      dialogTitle: '',
      dialogKeyTitle: '',
      pageData: [],
      choiceCusts: [],
      cust_list: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fKeyData: '',
        fDevMacAddr: '',
        fLastTime: ''
      },
      cust: {
        fUsrName: '',
        fCustNo: '',
        fCustName: '',
        fDevAccNo: '',
        fDevMacAddr: '',
        fKeyData: '',
        fLastTime: '',
        fStatusName: '',
        fLinkman: ''
      },
      custKey: {
        fKeyID: '',
        fKeyData: ''
      }
    }
  },
  methods: {
    ...mapActions([
      'getCustByGroup'
    ]),
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.init()
      }, 1000)
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      api.custKeyPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载激活码信息失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.dialogTitle = '查看激活码'
      this.formDisabled = true
      this.dialogFormVisible = true
      this.cust = row
      // api.custInfo(row.fCustID).then(res => {
      //   if (res && res.data) {
      //     var data = res.data
      //     if (data.IsOk) {
      //       data.Data = data.Data || {}
      //       this.cust = data.Data
      //     } else {
      //       this.$message.error(data.Msg)
      //     }
      //   }
      // })
    },
    handleEdit (index, row) {
      this.dialogKeyTitle = '编辑激活码'
      this.KeyFormDisabled = false
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogKeyFormVisible = true
      api.custKeyInfo(row.fKeyID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            this.custKey = data.Data
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleDelete (index, row) {
      this.$confirm('此操作将永久删除该客户[' + row.fCustName + '], 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.custKeyDelete(row.fKeyID).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.init()
            } else {
              this.$message.error(data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    custKeyRecovery (index, row) {
      this.$confirm('将客户[' + row.fCustName + ']的激活码回收, 是否继续?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.custKeyRecovery(row.fKeyID).then(res => {
          if (res && res.data) {
            let { status, data } = res
            if (status === 200) {
              if (data.IsOk) {
                this.$message({
                  type: 'success',
                  message: '操作完成'
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          }
        })
      }).catch(() => { })
    },
    handleAdd () {
      this.dialogKeyTitle = '新增激活码'
      this.custKey = {
        fKeyID: '',
        fKeyData: ''
      }
      setTimeout(() => {
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].clearValidate()
        }
      }, 50)
      this.keyFormDisabled = false
      this.dialogKeyFormVisible = true
    },
    formatType (row, column, cellValue, index) {
      if (cellValue === '0') {
        return '封闭式'
      } else {
        return '路侧'
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          api.custKeyEdit(this.custKey).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogKeyFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    tab_click (tab) {
      // this.setTabHeight($('#' + tab.$el.id).height())
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    },
    loadCust () {
      park.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 240000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
            this.is_del = data.Data.data.is_del
            this.is_syn = data.Data.data.is_syn
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    this.loadCust()
    this.getCustByGroup({ fCustTypeID: 1 }).then(res => {
      if (res && res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            let all = {}
            all['fCustID'] = ' '
            all['unionName'] = '所有客户'
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#custMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#custMain .el-dialog__title {
  color: white;
}
#custMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#custMain .el-dialog__body {
  padding: 30px 20px 0px 20px;
}
#custMain .is-disabled .el-input__inner,
#custMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#custMain #fRemark {
  height: 180px;
}
#custMain .fRemark_row .el-form-item__content {
  height: 180px;
}
</style>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/cust/custKey.vue